(() => {
  const SEL = '[data-zerra-voices]';
  const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  function init(root) {
    if (!root || root.dataset.voicesReady === '1') return;
    root.dataset.voicesReady = '1';

    const viewport = root.querySelector('[data-voices-viewport]');
    const track = root.querySelector('[data-voices-track]');
    const cards = [...root.querySelectorAll('[data-voices-card]')];
    const prevBtn = root.querySelector('[data-voices-prev]');
    const nextBtn = root.querySelector('[data-voices-next]');
    const dotsRoot = root.querySelector('[data-voices-dots]');
    const currentEl = root.querySelector('[data-voices-current]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = root.dataset.autoplay !== 'false';
    const interval = Math.max(3000, parseInt(root.dataset.interval || '3000', 10));

    let index = 0;
    let dots = [];
    let cardW = 0;
    let gap = 0;
    let dragX = 0;
    let startX = 0;
    let dragging = false;
    let animating = false;
    let timer = null;
    let isPaused = false;

    if (!viewport || !track || cards.length === 0) return;

    const mod = (n) => ((n % cards.length) + cards.length) % cards.length;

    const measure = () => {
      const styles = getComputedStyle(track);
      gap = parseFloat(styles.columnGap || styles.gap) || 0;
      cardW = cards[0].offsetWidth;
    };

    const offsetFor = (i) => {
      const vp = viewport.getBoundingClientRect().width;
      return -(i * (cardW + gap)) + (vp - cardW) / 2;
    };

    const stopAutoplay = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (!autoplay || reduce || isPaused || cards.length < 2) return;
      timer = window.setInterval(() => {
        if (isPaused || dragging || animating) return;
        go(index + 1);
      }, interval);
    };

    const buildDots = () => {
      if (!dotsRoot) return;
      dotsRoot.innerHTML = '';
      if (cards.length < 2) {
        dotsRoot.hidden = true;
        dots = [];
        return;
      }
      dotsRoot.hidden = false;
      cards.forEach((_, i) => {
        const li = document.createElement('li');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'zerra-voices__dot';
        btn.setAttribute('aria-label', `Vai alla recensione ${i + 1}`);
        btn.addEventListener('click', () => {
          go(i);
          startAutoplay();
        });
        li.appendChild(btn);
        dotsRoot.appendChild(li);
      });
      dots = [...dotsRoot.querySelectorAll('.zerra-voices__dot')];
    };

    const applyTransform = (x, animate) => {
      track.style.transition = animate && !reduce ? `transform 0.55s ${EASE}` : 'none';
      track.style.transform = `translate3d(${x}px, 0, 0)`;
    };

    const syncClasses = () => {
      cards.forEach((card, i) => {
        const on = i === index;
        card.classList.toggle('is-active', on);
        card.setAttribute('aria-hidden', on ? 'false' : 'true');
        card.tabIndex = on ? 0 : -1;
      });

      dots.forEach((dot, i) => {
        const on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });

      if (prevBtn) prevBtn.disabled = cards.length < 2;
      if (nextBtn) nextBtn.disabled = cards.length < 2;
      if (currentEl) currentEl.textContent = String(index + 1).padStart(2, '0');
    };

    const go = (next, animate = true) => {
      if (cards.length < 1) return;
      if (animating && animate) return;
      index = mod(next);
      measure();
      const x = offsetFor(index);
      syncClasses();
      if (animate && !reduce) {
        animating = true;
        applyTransform(x, true);
        window.setTimeout(() => {
          animating = false;
        }, 560);
      } else {
        applyTransform(x, false);
      }
    };

    const onPointerDown = (e) => {
      if (cards.length < 2) return;
      dragging = true;
      isPaused = true;
      stopAutoplay();
      startX = e.clientX;
      dragX = 0;
      track.style.transition = 'none';
      viewport.setPointerCapture?.(e.pointerId);
      root.classList.add('is-dragging');
    };

    const onPointerMove = (e) => {
      if (!dragging) return;
      dragX = e.clientX - startX;
      measure();
      applyTransform(offsetFor(index) + dragX, false);
    };

    const onPointerUp = () => {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      const threshold = Math.min(80, cardW * 0.18);
      if (dragX <= -threshold) go(index + 1);
      else if (dragX >= threshold) go(index - 1);
      else go(index);
      dragX = 0;
      isPaused = false;
      startAutoplay();
    };

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerUp);
    viewport.addEventListener('pointerleave', () => {
      if (dragging) onPointerUp();
    });

    cards.forEach((card, i) => {
      card.addEventListener('click', () => {
        if (Math.abs(dragX) > 8) return;
        if (i === index) return;
        go(i);
        startAutoplay();
      });
    });

    prevBtn?.addEventListener('click', () => {
      go(index - 1);
      startAutoplay();
    });
    nextBtn?.addEventListener('click', () => {
      go(index + 1);
      startAutoplay();
    });

    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(index - 1);
        startAutoplay();
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(index + 1);
        startAutoplay();
      }
    });

    root.addEventListener('mouseenter', () => {
      isPaused = true;
      stopAutoplay();
    });
    root.addEventListener('mouseleave', () => {
      isPaused = false;
      startAutoplay();
    });
    root.addEventListener('focusin', () => {
      isPaused = true;
      stopAutoplay();
    });
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget)) {
        isPaused = false;
        startAutoplay();
      }
    });

    let resizeTimer = 0;
    const onResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => go(index, false), 100);
    };
    window.addEventListener('resize', onResize);

    buildDots();
    requestAnimationFrame(() => {
      measure();
      go(0, false);
      startAutoplay();
    });

    if (reduce) root.classList.add('is-reduced');

    root._zerraVoicesTeardown = () => {
      stopAutoplay();
      window.removeEventListener('resize', onResize);
      delete root.dataset.voicesReady;
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll(SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll(SEL).forEach((root) => {
      if (typeof root._zerraVoicesTeardown === 'function') root._zerraVoicesTeardown();
    });
  });
})();
